var _mask, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_2827_99237",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.31417 8.88212V11.8214C9.31417 12.7492 8.56342 13.5 7.6356 13.5H2.32603C1.39821 13.5 0.647461 12.7492 0.647461 11.8214V6.51182C0.647461 5.584 1.39821 4.83325 2.32603 4.83325H4.982"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.31417 8.88212V11.8214H10.3142V8.88212H8.31417ZM8.31417 11.8214C8.31417 12.1969 8.01113 12.5 7.6356 12.5V14.5C9.1157 14.5 10.3142 13.3015 10.3142 11.8214H8.31417ZM7.6356 12.5H2.32603V14.5H7.6356V12.5ZM2.32603 12.5C1.9505 12.5 1.64746 12.1969 1.64746 11.8214H-0.352539C-0.352539 13.3015 0.845929 14.5 2.32603 14.5V12.5ZM1.64746 11.8214V6.51182H-0.352539V11.8214H1.64746ZM1.64746 6.51182C1.64746 6.13629 1.9505 5.83325 2.32603 5.83325V3.83325C0.845929 3.83325 -0.352539 5.03172 -0.352539 6.51182H1.64746ZM2.32603 5.83325H4.982V3.83325H2.32603V5.83325Z",
    fill: "white",
    fillOpacity: 0.75,
    mask: "url(#path-1-inside-1_2827_99237)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.65904 1H11.9686C12.6195 1 13.1472 1.52766 13.1472 2.17857V7.48814C13.1472 8.13905 12.6195 8.66671 11.9686 8.66671H6.65904C6.00813 8.66671 5.48047 8.13905 5.48047 7.48814V2.17857C5.48047 1.52766 6.00813 1 6.65904 1Z",
    stroke: "white",
    strokeOpacity: 0.75,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy_icon.619f68f73a90ac99b7c65504dc2905f0.svg";
export { ForwardRef as ReactComponent };